import type { ReactNode } from 'react';
import { Link, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';

/**
 * Yardım sayfalarının içeriği — client-side, statik. Legacy `Home/{Releases,Privacy,Rules}`
 * view'ları içeriği CMS/DB'den alıyordu; `Content/GetStaticPage` API'de yok (bkz.
 * docs/backend-requirements.md N-6). Gizlilik / Kurallar'ın bağlayıcı tam metni rezervasyon
 * onay ekranında sunulur; buradaki özet yönlendirmedir. `HesCode` (COVID dönemi) çıkarıldı.
 */
export type HelpPageKey = 'releases' | 'privacy' | 'rules';

interface HelpPage {
  title: string;
  body: ReactNode;
}

const support = (
  <Link href="/support">Destek</Link>
);

export const HELP_CONTENT: Record<HelpPageKey, HelpPage> = {
  releases: {
    title: 'Sürüm Notları',
    body: (
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary">
          Panelin yeni React sürümü kademeli olarak yayınlanmaktadır. Öne çıkan değişiklikler:
        </Typography>
        <List dense>
          <ListItem disableGutters>
            <ListItemText
              primary="Uçak / Otel / Otobüs / Transfer / Araç Kiralama rezervasyon akışları"
              secondary="Arama → seçim → yolcu → ödeme → belge adımları tek bir akış motorunda."
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemText
              primary="Rezervasyon ve Bilet detay ayrımı"
              secondary="Ön rezervasyonda İptal Et / Opsiyon-Fiyat; biletlenmiş kayıtta Void / İade."
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemText
              primary="Kayıtlı yolcu araması"
              secondary="Uçuş yolcu formunda ad veya T.C. kimlik ile kayıtlı yolcuyu bulup alanları doldurma."
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemText
              primary="Kurumsal modül"
              secondary="Politikalar, masraf merkezleri, departman/unvan, personel ve onay kuyrukları."
            />
          </ListItem>
        </List>
        <Typography variant="body2" color="text.secondary">
          Sorun bildirmek veya öneri iletmek için {support} bölümünü kullanabilirsiniz.
        </Typography>
      </Stack>
    ),
  },
  privacy: {
    title: 'Kişisel Verilerin Korunması ve Gizlilik Politikası',
    body: (
      <Stack spacing={2}>
        <Typography variant="body2">
          Rezervasyon işlemleri sırasında paylaştığınız kişisel veriler (ad-soyad, iletişim
          bilgileri, kimlik/pasaport ve seyahat bilgileri) yalnızca talep ettiğiniz seyahat
          hizmetinin sağlanması, biletleme, faturalama ve yasal yükümlülüklerin yerine
          getirilmesi amacıyla işlenir ve ilgili hizmet sağlayıcılarla (havayolu, otel,
          transfer vb.) bu amaçla paylaşılır.
        </Typography>
        <Typography variant="body2">
          Kişisel Verilerin Korunması ve Gizlilik Politikası'nın <strong>bağlayıcı güncel tam
          metni</strong>, ödeme adımındaki onay kutusunda bağlantılı olarak sunulur ve
          işlemi tamamlamadan önce kabul edilmesi gerekir.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Verilerinize ilişkin talepleriniz (erişim, düzeltme, silme) için {support} bölümünden
          acentenize ulaşabilirsiniz.
        </Typography>
      </Stack>
    ),
  },
  rules: {
    title: 'Acente ve Bilet Kuralları',
    body: (
      <Stack spacing={2}>
        <Typography variant="body2">
          Bu panel üzerinden yapılan rezervasyon ve biletleme işlemleri, ilgili hizmet
          sağlayıcının (havayolu, otel, otobüs firması, transfer/araç kiralama tedarikçisi)
          kendi tarife, iptal, iade ve değişiklik kurallarına tabidir. Ücret koşulları,
          değişiklik/iade cezaları ve bagaj hakları seçtiğiniz ürüne göre değişir ve seçim
          ekranında gösterilir.
        </Typography>
        <Typography variant="body2">
          İptal ve iade işlemleri yalnızca ürünün kurallarının izin verdiği ölçüde ve süre
          içinde yapılabilir. Otobüs ve transfer ürünlerinde satış sonrası iptal sağlayıcı
          tarafından desteklenmemektedir.
        </Typography>
        <Typography variant="body2">
          Kuralların <strong>bağlayıcı güncel tam metni</strong> ödeme adımındaki onay
          kutusunda sunulur. Sorularınız için {support} bölümünü kullanabilirsiniz.
        </Typography>
      </Stack>
    ),
  },
};
